import * as config from './index';
export const OPERATION_MODULE = {
  inStorePicking: config.inStorePicking,
  returnManagement: config.returnManagement,
  inStorePickingDetail: config.inStorePickingDetail,
  inStoreLocation: config.inStoreLocation,
  confirmationDispatches: config.confirmationDispatches,
  dispatchToCustomer: config.dispatchToCustomer,
  dispatchToCustomerDetail: config.dispatchToCustomerDetail,
  detailDispatchTrip: config.detailDispatchTrip,
  trip: config.trip,
  reazonRejection: config.reazonRejection,
  detailTrip: config.detailTrip,
  dispatchesCanceled: config.dispatchCanceled,
  guidePrint: config.guidePrint,
  travelCode: config.reasonGuidePrint,
  dispatchesCanceledState: config.dispatchesCanceledState,
  dispatchCode: config.reasonGuidePrintDispatch,
  detailDispatchWithdraw: config.detailDispatchWithdraw,
  inStoreListDeliver: config.inStoreListDeliver,
  dispatchProductPreCancellation: config.dispatchProductPreCancellation,
  dispatchesNotLoaded: config.dispatchesNotLoaded,
  dispatchesToLoad: config.dispatchesToLoad,
  dispatchesToLoadTrip: config.dispatchesToLoadTrip,
  tripsMassive: config.tripsMassive,
  tripImport: config.tripImport,
  detailTripDeliver: config.DetailTripDeliver,
  tripDeliver: config.TripDeliver,
  confirmationImport: config.confirmationImport,
  formatSkuInCustomerDispatch: config.formatSkuInCustomerDispatch,
  formatDispatchInCustomerDispatch: config.formatDispatchInCustomerDispatch,
  dispatchNotProcessed: config. dispatchNotProcessed,
  orderDeliveryTurbo: config.OrderDeliveryTurbo,
  dispatchTripBeetrack: config.DispatchTripBeetrack,
  dispatchTrips: config.dispatchTrips,
  exchangeManagement: config.exchangeManagement,
  exchangeManagementDetail: config.exchangeManagementDetail,
  dispatchSelected: config.dispatchSelected,
  dispatchSelectedResp: config.dispatchSelectedResp,
};
